import { Callback } from '@csp/csp-common-model';
import { useEffect } from 'react';

export const useOnUnmount = (cleanup: Callback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => (): void => cleanup(), []);
};
